import React from 'react';

import classNames from 'classnames';

import SelectAdvancedFilter from '../../lib/SelectAdvancedFilter';
import { useCompaniesContext } from '../CompaniesContext';
import { SHOPS_PER_YEAR_LABELS } from '../create/constants';

const CompaniesFiltersShopsPerYear = () => {
  const { filters, setFilters } = useCompaniesContext();

  const options = Object.keys(SHOPS_PER_YEAR_LABELS).map((key: any) => ({
    label: SHOPS_PER_YEAR_LABELS[key],
    value: key,
  }));

  const handleSelect = (selection: any[]) => {
    const values = selection.map((item: any) => item.value);
    setFilters({ ...filters, page: 1, shops_per_year: values });
  };

  return (
    <SelectAdvancedFilter
      placeholder={'Shops per Year'}
      className={classNames({ active: Boolean(filters.shops_per_year?.length) })}
      options={options}
      defaultValue={filters?.shops_per_year ?? []}
      onSelect={handleSelect}
    />
  );
};

export default CompaniesFiltersShopsPerYear;
